exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list-item.active-item[data-v-5e2e3e78]{color:var(--v-secondary-base)!important}", ""]);

// exports
